import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import DataTable from "react-data-table-component";
import "../assets/CSS/Dashboard.css";

   const initialFormData = {
    Responsible_Person: "",
    Department: "",
    LOT_ID: "",
    // ProcessName: "",
    CheckPoints: [],
    OtherDetails: "",
    CreatedBy: ""
  };
 function CheckPoints() {


  const [departments, setDepartments]   = useState([]);
  // const [activeDept, setActiveDept]     = useState("");
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [availableCheckpoints, setAvailableCheckpoints] = useState([]);
  const [showModal, setShowModal]       = useState(false);
  const [formData, setFormData] = useState({ ...initialFormData });
  const [formEntries, setFormEntries]   = useState([]);
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState(null);
  // const [selectedRow, setSelectedRow]   = useState(null);

  const user       = JSON.parse(localStorage.getItem("userData")) || {};
  const supervisor = user.Name       || "";
  const userDept   = user.Department || "";

    const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

    // Reset form to initial values + defaults
  const resetForm = useCallback(() => {
    setFormData({
      ...initialFormData,
      Responsible_Person: supervisor,
      Department: userDept,
      CreatedBy: supervisor
    });
  }, [supervisor, userDept]);

  // 1️⃣ Fetch departments for this supervisor
 // Fetch supervisor's departments
  const fetchDepartments = useCallback(async () => {
    try {
      const resp = await axiosInstance.get("/api/get-supervisor-departments", {
        params: { supervisor }
      });
      setDepartments(resp.data);
      resetForm();
    } catch (err) {
      console.error("Error loading departments:", err);
      setError("Could not load departments.");
    }
  }, [supervisor, resetForm]);
  // 2️⃣ Fetch available checkpoints whenever Department changes
  useEffect(() => {
    if (!formData.Department) {
      setAvailableCheckpoints([]);
      return;
    }
    axiosInstance
      .get("/api/get-department-checkpoints", {
        params: {
          supervisor,
          department: formData.Department
        }
      })
      .then(res => setAvailableCheckpoints(res.data))
      .catch(err => {
        console.error("Error loading checkpoints:", err);
        setError("Could not load checkpoints.");
      });
  }, [formData.Department, supervisor]);

  // 3️⃣ Fetch all submitted form entries (filtered to your dept)
  //  const fetchFormEntries = useCallback(async () => {
  //   try {
  //     const resp = await axiosInstance.get("/api/get-CheckPoint-FormData");
  //     const entries = resp.data.filter(e => e.Department === userDept);
  //     setFormEntries(entries);
  //   } catch (err) {
  //     console.error("Error loading submissions:", err);
  //     setError("Could not load submission data.");
  //   }
  // }, [userDept]);

  // after: filter by CreatedBy (the supervisor’s name)
const fetchFormEntries = useCallback(async () => {
  try {
    const resp = await axiosInstance.get("/api/get-CheckPoint-FormData");
    // only rows where CreatedBy matches the logged-in user
    const entries = resp.data.filter(e => e.CreatedBy === supervisor);
    setFormEntries(entries);
  } catch (err) {
    console.error("Error loading submissions:", err);
    // setError("Could not load submission data.");
  }
}, [supervisor]);
  // Initial load
  useEffect(() => {
    fetchDepartments();
    fetchFormEntries();
  }, [fetchDepartments, fetchFormEntries]);

  // Form field change
  const handleFormChange = e => {
    const { name, value } = e.target;
    setFormData(fd => ({ ...fd, [name]: value }));
  };

  // // Multi‐select handler
  // const handleCheckPointSelect = e => {
  //   const opts = Array.from(e.target.selectedOptions).map(o => o.value);
  //   setFormData(fd => ({ ...fd, CheckPoints: opts }));
  // };

  // Checkbox toggle
  const handleCheckToggle = cp => {
    setFormData(fd => {
      const idx = fd.CheckPoints.indexOf(cp);
      const newList = idx > -1
        ? fd.CheckPoints.filter(x => x !== cp)
        : [...fd.CheckPoints, cp];
      return { ...fd, CheckPoints: newList };
    });
  };
  // Submit handler
  const handleFormSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      // Post one row per selected checkpoint
      await Promise.all(
        formData.CheckPoints.map(cp =>
          axiosInstance.post("/api/submit-checkpoint", {
            ...formData,
            CheckPoints: cp
          })
        )
      );
      alert("Submitted successfully");
      setShowModal(false);
      fetchFormEntries();
    } catch (err) {
      console.error("Submission error:", err);
      alert("Submission failed");
    } finally {
      setLoading(false);
    }
  };
 // Delete handler
  // const handleDelete = async id => {
  //   if (!window.confirm("Are you sure you want to delete this entry?")) return;
  //   try {
  //     await axiosInstance.delete(`/api/delete-checkpoint/${id}`);
  //     fetchFormEntries();
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //     alert("Failed to delete entry");
  //   }
  // };
  // Columns for the DataTable
  const columns = [
    // { name: "ID",         selector: row => row.id,                 sortable: true },
    { name: "Responsible Person",     selector: row => row.Responsible_Person, sortable: true },
    { name: "Department", selector: row => row.Department,         sortable: true },
    { name: "LOT ID",     selector: row => row.LOT_ID,             sortable: true },
    // { name: "Process",    selector: row => row.ProcessName,        sortable: true },
    { name: "Checkpoint", selector: row => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.CheckPoints}>
        {row.CheckPoints}
      </span>),        sortable: true },
     { name: "Details", selector: row =>(
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.OtherDetails}
        >
     {row.OtherDetails}
        </span>
    ) },
   { name: "Remarks", selector: (row) =>(
    <span
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    title={row.Remarks}
    >
    {row.Remarks || "N/A"}
    </span>
    ), sortable: true },
   {
    name: "Status",
    width: "100px",
    selector: (row) => row.Status || "N/A",
    sortable: true,
    cell: (row) => {
      const status = row.Status || "N/A";
      let bgColor = "transparent";
      let textColor = "black";
      let textbold = "normal";       // ← initialize here

      if (status === "Approved") {
        bgColor = "green";
        textColor = "white";
        textbold = "bold";  
      } else if (status === "Pending") {
        bgColor = "#fff3cd";
        textColor = "#856404";
        textbold = "bold";          // now this will work
      }

      return (
        <span
          style={{
            backgroundColor: bgColor,
            color: textColor,
            borderRadius: "4px",
            display: "inline-block",
            padding: "2px 2px",
            minWidth: "60px",
            textAlign: "center",
            fontWeight: textbold,    // uses the declared variable
          }}
        >
          {status}
        </span>
      );
    },
  },
    { name: "Created At", selector: row => row.CreatedAt,          sortable: true },
    { name: "Created By", selector: row => row.CreatedBy,          sortable: true }
    //  {
    //   name: "Actions",
    //   cell: row => (
    //     <button
    //       className="btn btn-sm btn-danger"
    //       onClick={() => handleDelete(row.id)}
    //     >
    //       Delete
    //     </button>
    //   )
    // }
  ];

  return (
    <div className="d-flex dashboard">
       <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
      <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "fit-content" }}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3>Checkpoints</h3>
            <button
              className="btn btn-success"
              onClick={() => setShowModal(true)}
            >
              + Add Checkpoints
            </button>
          </div>

          {error && <p className="text-danger">{error}</p>}

          <DataTable
            columns={columns}
            data={formEntries}
            pagination
            // selectableRows
            // onSelectedRowsChange={({ selectedRows }) =>
            //   setSelectedRow(selectedRows[0] || null)
            // }
          />

          {showModal && (
          <div className="modal show" style={{ display: "block",marginTop:"37px"  }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                    <h5 className="modal-title">Submit Checkpoints</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => { setShowModal(false); resetForm(); }}
                    />
                  </div>
                  <form onSubmit={handleFormSubmit}>
                    <div className="modal-body">
                    <div className="mb-3">
                    <label className="form-label">Responsible Person</label>
                    <select
                      name="Responsible_Person"
                      value={formData.Responsible_Person}
                      onChange={handleFormChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Responsible Person</option>
                      <option value="Khalid Qureshi">Khalid Qureshi</option>
                      <option value="VARUN">VARUN</option>
                      <option value="MONU ADMIN">MONU ADMIN</option>
                      <option value="SARFRAZ ADMIN">SARFRAZ ADMIN</option>
                    </select>
                  </div>
                  
                      <div className="mb-3">
                        <label className="form-label">Department</label>
                        <select
                          name="Department"
                          value={formData.Department}
                          onChange={handleFormChange}
                          className="form-control"
                          required
                        >
                          <option value="">Select Department</option>
                          {departments.map(d => (
                            <option key={d} value={d}>{d}</option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">LOT ID</label>
                        <input
                          type="text"
                          name="LOT_ID"
                          value={formData.LOT_ID}
                          onChange={handleFormChange}
                          className="form-control"
                          required
                        />
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label">Process Name</label>
                        <input
                          type="text"
                          name="ProcessName"
                          value={formData.ProcessName}
                          onChange={handleFormChange}
                          className="form-control"
                          required
                        />
                      </div> */}
                         <div className="mb-3">
                        <label className="form-label">Checkpoints</label>
                        <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                          {availableCheckpoints.map(cp => (
                            <div key={cp.id} className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`cp-${cp.id}`}
                                checked={formData.CheckPoints.includes(cp['CHECK POINT'])}
                                onChange={() => handleCheckToggle(cp['CHECK POINT'])}
                              />
                              <label className="form-check-label" htmlFor={`cp-${cp.id}`}>{cp['CHECK POINT']}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                      {/* <div className="mb-3">
                        <label className="form-label">Checkpoints</label>
                        <select
                          multiple
                          className="form-control"
                          value={formData.CheckPoints}
                          onChange={handleCheckPointSelect}
                          required
                        >
                          {availableCheckpoints.map(cp => (
                            <option key={cp.id} value={cp["CHECK POINT"]}>
                              {cp["CHECK POINT"]}
                            </option>
                          ))}
                        </select>
                      </div> */}
                      <div className="mb-3">
                        <label className="form-label">Other Details</label>
                        <textarea
                          name="OtherDetails"
                          value={formData.OtherDetails}
                          onChange={handleFormChange}
                          className="form-control"
                          rows={3}
                          placeholder="Enter remarks"
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? "Submitting…" : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                          onClick={() => { setShowModal(false); resetForm(); }}
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default CheckPoints